import React, { useState } from "react";
import ContainerFull from "../Container/ContainerFull.jsx";

const AgentLogin = ({ redirect }) => {
  const [agentId, setAgentId] = useState("");
  const [error, setError] = useState("");

  const handleSubmit = async e => {
    e.preventDefault();
    setError(""); // Clear previous error

    const endpoint = `/api/ESB/GetOfficesByAgentId?agentId=${encodeURIComponent(agentId)}`;

    try {
      const response = await fetch(endpoint, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
        },
      });

      const data = await response.json();

      if (!data.Success) {
        setError(data.ErrorMessage || "An unknown error occurred.");
      } else {
        setError("");
        // Set cookie on success
        document.cookie =
          "stewartpreferred=stewartpreferred; path=/; SameSite=Lax";
        // Redirect if redirect prop is provided
        if (redirect) {
          window.location.href = redirect;
        }
      }
    } catch (error) {
      setError("A network error occurred.");
    }
  };

  return (
    <ContainerFull>
      <form
        className="sc-form login-form agent-login-form"
        onSubmit={handleSubmit}
      >
        <h2>Login</h2>

        <div className="field-wrapper">
          <label htmlFor="agent-id" className="agent-id-label">
            Agent ID
          </label>
          <input
            name="agent-id"
            id="agent-id"
            value={agentId}
            onChange={e => setAgentId(e.target.value)}
          />
        </div>
        {error && <div className="error-message">{error}</div>}

        <button type="submit" className="btn btn--primary-large">
          Submit
        </button>
      </form>
    </ContainerFull>
  );
};

export default AgentLogin;
